import { useFeatureFlagsStore } from '@/stores/useFeatureFlags';
import { useUserDetailsStore } from '@/stores/useUserDetails';
import { featureFlagSlugs } from '@/constants/featureFlagSlugs';

/**
 * Whether the Feature Announcements feature is available to this carrier at all — the
 * kill switch for every entry point (login modal, What's New nav entry + panel), not a
 * per-announcement gate. An individual announcement may additionally declare its own
 * `featureFlagSlug`, which the store handles separately via `isEligible`.
 *
 * `isFullySignedUp` rides along with the flag because a carrier mid-signup shouldn't be
 * shown what's new in a product they haven't finished joining — this mirrors what
 * app.vue already required of the login modal, kept in one place now that the header
 * entry points need the same answer.
 */
export const useIsFeatureAnnouncementEnabled = () => {
  const featureFlagsStore = useFeatureFlagsStore();
  const userDetailsStore = useUserDetailsStore();

  const isFeatureAnnouncementEnabled = computed(
    () =>
      Boolean(featureFlagsStore.getByFlagName(featureFlagSlugs.featureAnnouncement)) &&
      userDetailsStore.isFullySignedUp,
  );

  return { isFeatureAnnouncementEnabled };
};
